<div class="row padded-row padded-top">
    <div class="col-sm-12">
        <p class="font-bold">
            Your session has timed out.
        </p>
        <p>
            Please return to the <a [routerLink]="['/']">home page</a> to begin a new modeling session.
        </p>
    </div>
</div>